import React, { useEffect, useState } from "react";
import Button from "./Buttons/Button";
import "./BonusSection.scss";
import { getBonusByID } from "../services/getBonusByID";
import { ImageLink } from "../constants";

const BonusSection = ({
  subCategoryId = "",
  setIsModelOpen = () => {},
  btnDisabled = false,
}) => {
  const [pageData, setPageData] = useState([]);

  const fetchData = async () => {
    await getBonusByID({
      subCategoryId,
    })
      .then((data) => {
        setPageData(data.data);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchData();
  }, []);
  if(!pageData?.length){
    return null;
  }

  return (
        <div className="container">
          <div className="bonus-container">
            <h2 className="title">Bonuses, What You’ll Receive</h2>
            <p className="description">More value, more support, more academic confidence</p>

            <div className="bonus-card-container">
              <div className="bonus-section-bg-overlay"></div>
              {pageData?.map((element, index) => {
                return <BonusCard {...element} key={index} />;
              })}
            </div>
            {!btnDisabled ? (
              <Button
                text={"Get it Now"}
                className="mt-0"
                varient="primary"
                onClick={() => setIsModelOpen(true)}
              />
            ) : (
              <></>
            )}
          </div>
          </div>
    
  );
};

const BonusCard = ({ image = "", description = "", index = 0, title = "" }) => {
  return (
    <div className="bonus-card" key={index}>
      <div className="bonus-card-icon d-flex justify-content-center align-items-center">
        <img src={ImageLink(image)} alt="" />
      </div>
      <div className="bonus-card-title text-center">{title}</div>
      <div className="bonus-card-description text-center">{description}</div>
    </div>
  );
};

export default BonusSection;
